import { createContext, useContext } from 'react';

interface AuthContextType {
    user: UserInfo | null;
    login: (userData: UserInfo) => void;
    logout: (shouldPost: boolean) => void;
    loading: boolean;
}

const defaultAuthContext: AuthContextType = {
    user: null,
    login: () => {},
    logout: (_shouldPost: boolean) => {},
    loading: true,
};

export interface AllowedGrades {
    elementary: string[];
    middleSchool: string[];
}
export interface UserInfo {
    id: string;
    username: string;
    role: string;
    name: string;
    gradeShortCode: string;
    alternateGradeShortCodes: string[];
    handscoreQuestionCount: number;
    isPracticeAllowed: boolean;
    alternateGradeColorShortCode?: string;
    minFontSize?: number;
}

export const AuthContext = createContext<AuthContextType>(defaultAuthContext);

export const useAuth = () => useContext(AuthContext);
